import React from 'react';
import { Chip } from '@mui/material';

import formStates, { FormStates } from '../../constants/formStates';

export const FormStateChip = ({ state }: { state?: FormStates }) => (
  state === formStates.DRAFT
    ? <Chip size="small" variant="outlined" color="warning" label="Draft" />
    : <Chip size="small" variant="outlined" color="success" label="Published" />
);

export const FormActivityChip = ({ inactive, archived }: {
  inactive?: boolean;
  archived?: boolean;
}) => {
  if (archived) return <Chip size="small" variant="outlined" label="Archived" />;
  if (inactive) return <Chip size="small" variant="outlined" label="Inactive" />;
  return null;
};
